import React from "react";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {ButtonGroup, ButtonGroupItem} from "@/components/CustomRadioGroup";

interface StepRichiesteVeicoloProps {
    formRichiesteVeicolo: any;
}

const StepRichiesteVeicolo: React.FC<StepRichiesteVeicoloProps> = ({formRichiesteVeicolo}) => (
    <Form {...formRichiesteVeicolo}>
        <form id="formRichiesteVeicolo" onSubmit={formRichiesteVeicolo.handleSubmit(() => {})}
              className="grid grid-cols-1 gap-4">

            {/* Bollo pagato */}
            <FormField control={formRichiesteVeicolo.control} name="reqBollo"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Bollo pagato?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Quante chiavi possiedi? */}
            <FormField control={formRichiesteVeicolo.control} name="reqNChiavi"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Quante chiavi possiedi?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="1" label="1"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="2+" label="2+"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Secondo set di pneumatici? */}
            <FormField control={formRichiesteVeicolo.control} name="reqSetGomme"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Secondo set di pneumatici?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Libretto di manutenzione */}
            <FormField control={formRichiesteVeicolo.control} name="reqLibroMan"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Hai il libretto di manutenzione (o certificato
                                   digitale)?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Revisione */}
            <FormField control={formRichiesteVeicolo.control} name="reqRevisione"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Hai fatto la revisione dell'auto negli ultimi 6
                                   mesi?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Scaduta" label="Scaduta"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Come vendi */}
            <FormField control={formRichiesteVeicolo.control} name="reqPrivato"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Come vendi?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Privato" label="Privato"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Azienda" label="Azienda"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* L'auto è stata importata */}
            <FormField control={formRichiesteVeicolo.control} name="reqImportata"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>L'auto è stata importata?</FormLabel>
                               <FormControl>
                                   <ButtonGroup ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Si" label="Si"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="No" label="No"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Colore esterno */}
            <FormField control={formRichiesteVeicolo.control} name="reqColoreEsterno"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Qual è il colore dell'esterno della tua auto?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Nero" label="Nero"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Bianco" label="Bianco"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Grigio" label="Grigio"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Blu" label="Blu"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Rosso" label="Rosso"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Altro" label="Altro"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Colore sedili */}
            <FormField control={formRichiesteVeicolo.control} name="reqColoreSedili"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Qual è il colore dei sedili della tua auto?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Nero" label="Nero"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Bianco" label="Bianco"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Grigio" label="Grigio"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Blu" label="Blu"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Rosso" label="Rosso"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Altro" label="Altro"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />

            {/* Materiale sedili */}
            <FormField control={formRichiesteVeicolo.control} name="reqMaterialeSedili"
                       render={({field, fieldState}) => (
                           <FormItem>
                               <FormLabel>Di che materiale sono i sedili?</FormLabel>
                               <FormControl>
                                   <ButtonGroup columns={3} ref={field.ref} value={field.value}
                                                onValueChange={(value) => field.onChange(value)}>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Pelle" label="Pelle"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Tessuto" label="Tessuto"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Parzialmente in pelle"
                                                        label="Parzialmente in pelle"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Materiale sintetico"
                                                        label="Materiale sintetico"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Alcantara" label="Alcantara"/>
                                       <ButtonGroupItem className="w-full justify-between px-3"
                                                        value="Altro" label="Altro"/>
                                   </ButtonGroup>
                               </FormControl>
                               <FormMessage>{fieldState.error?.message}</FormMessage>
                           </FormItem>
                       )}
            />
        </form>
    </Form>
);

export default StepRichiesteVeicolo;
